var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressIllustrationLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 196,
    viewBox: "0 0 189 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.093 165.003C163.212 169.134 159.539 171.799 156.635 173.904C122.531 198.648 82.1773 191.435 73.6009 189.673C60.9393 187.074 36.4576 182.047 18.7593 161.001C-8.01759 129.16 -3.84774 78.9943 16.9224 45.8798C20.7214 39.822 40.7898 6.20338 81.5787 0.811932C106.263 -2.45143 135.035 4.12606 155.876 21.7826C199.616 58.8388 196.502 133.695 167.093 165.003Z",
    fill: "#9C9C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.229 29.6673L64.8295 23.252L4.42969 30.5064V184.825L64.8295 181.006L125.229 185.241L185.553 178.776V26.0802L125.229 29.6673Z",
    fill: "#FA9C03"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1264 177.491L8.73926 181.115V34.7219L66.1264 27.8398V177.491Z",
    fill: "#91B3FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.512 181.509L66.124 177.491V27.8398L123.512 33.9258V181.509Z",
    fill: "#BDD0FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.828 175.373L123.513 181.505V33.9225L180.828 30.5195V175.373Z",
    fill: "#91B3FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1258 27.8398H64.8262V177.533H66.1258V27.8398Z",
    fill: "url(#paint0_linear_5241_15665)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5241_15665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 27,
    width: 173,
    height: 155
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.422 33.7266L66.0353 27.6406L8.64746 34.5227V180.916L66.0353 177.292L123.422 181.31L180.738 175.178V30.3237L123.422 33.7266Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5241_15665)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.128 35.3984L155.006 47.0656L144.865 56.8112L132.913 45.4142L140.128 35.3984Z",
    fill: "#FFF8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5752 58.3011L43.8163 45.4141L65.4753 51.8576V68.2075L42.5752 58.3011Z",
    fill: "#FFF8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.597 138.476L178.609 132.328L180.235 144.8L169.735 148.257L166.597 138.476Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4111 148.399L65.4728 154.757L77.4966 152.72L76.4096 144.294L65.4728 141.701L53.4111 148.399Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1156 58.6699L8.3877 70.4809L9.08668 73.238L13.8131 71.5323L44.098 81.3477L44.6043 79.123L17.3005 70.2743L40.7303 61.819L62.5895 79.0215L59.5816 103.846L35.6764 105.872L14.6545 139.699L16.5939 141.415L36.9547 108.651L61.6931 106.556L65.1983 77.6232L41.1156 58.6699Z",
    fill: "url(#paint1_linear_5241_15665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.898 158.355L5.90918 133.079L7.47021 130.881L32.4597 156.157L30.898 158.355Z",
    fill: "url(#paint2_linear_5241_15665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.786 133.169L111.874 89.3555L109.637 90.4393L117.482 113.49L79.3799 127.469L80.0899 130.224L118.394 116.17L124.549 134.253L126.786 133.169Z",
    fill: "url(#paint3_linear_5241_15665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.643 124.643L151.382 134.066L137.042 100.486L135.32 101.532L149.978 135.857L150.023 135.829L144.431 143.086L146.209 145.037L160.42 126.592L158.643 124.643Z",
    fill: "url(#paint4_linear_5241_15665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.912 66.4211L148.511 64.0751C148.475 64.1053 148.441 64.1381 148.409 64.1732C149.176 63.2776 159.581 48.2548 166.387 38.3751L167.237 37.1426L182.717 55.8004L181.004 57.8263L167.404 41.4368C165.908 43.6044 162.657 48.3161 159.4 53.013C150.38 66.0227 150.132 66.2343 149.912 66.4211Z",
    fill: "url(#paint5_linear_5241_15665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.716 81.6878L113.865 61.8729L107.936 43.8109L81.3948 45.6936L81.251 42.8174L109.543 40.8105L116.167 61.0034L121.034 80.8797L118.716 81.6878Z",
    fill: "url(#paint6_linear_5241_15665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4224 58.9129L40.4961 58.7366L41.5019 43.0488L65.6686 49.0086L65.2778 51.2657L43.2604 45.8362L42.4224 58.9129Z",
    fill: "url(#paint7_linear_5241_15665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.562 58.4926L143.357 56.6917L153.408 47.1131L139.48 35.152L140.609 33.2812L156.603 47.018L144.562 58.4926Z",
    fill: "url(#paint8_linear_5241_15665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.537 147.611L167.516 79.8438L165.192 80.6257L177.284 131.771L165.974 137.56L166.736 139.679L177.603 134.116L178.905 144.105L170.443 146.891L170.957 149.113L180.631 145.927L181.213 148.393L183.537 147.611Z",
    fill: "url(#paint9_linear_5241_15665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8888 174.574L30.3574 157.708L31.2504 155.031L65.024 171.063L74.6386 155.02L65.9968 157.483L51.2761 149.311L52.295 146.699L66.2535 154.447L80.3591 150.428L65.8888 174.574Z",
    fill: "url(#paint10_linear_5241_15665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.072 143.64L118.893 174.864L94.3273 147.616L80.4928 126.781L78.9785 128.213L92.8585 149.116L92.9039 149.185L117.582 176.557L113.748 181.509L115.521 183.464L144.846 145.595L143.072 143.64Z",
    fill: "url(#paint11_linear_5241_15665)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.2927 80.4607L64.8546 69.3253C45.9441 61.3714 24.4055 53.1481 7.69727 52.2032L7.80046 49.6133C24.8624 50.5786 46.7154 58.9387 65.8371 66.9892L66.0971 67.0985L74.9032 78.7219L73.2927 80.4607Z",
    fill: "#FFF8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.419 169.171C160.997 155.678 140.161 140.825 125.687 135.083L78.6296 155.808L77.877 153.375L125.644 132.338L126.003 132.479C140.718 138.205 161.879 153.28 180.56 166.96L179.419 169.171Z",
    fill: "#FFF8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5367 71.163L73.0898 28.4905L75.1043 27.5195L89.5518 70.1914L87.5367 71.163Z",
    fill: "#FFF8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.007 82.9676C149.27 65.6707 142.068 53.7582 130.997 46.5496L132.038 44.2734C138.147 48.2504 143.214 53.6757 147.095 60.3977C150.621 66.5035 153.243 73.674 155.111 82.3203L153.007 82.9676Z",
    fill: "url(#paint12_linear_5241_15665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1931 154.07L38.3789 152.619L59.7276 113.406L61.5418 114.857L40.1931 154.07Z",
    fill: "#FFF8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.001 84.4459L96.2832 81.4632L96.3699 78.8718L158.615 81.8327L181.448 70.6641L182.273 73.0629L159.001 84.4459Z",
    fill: "#FFF8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1292 169.03L8.34766 166.61L65.3261 140.387L76.5203 141.714L76.3056 144.294L65.6261 143.028L9.1292 169.03Z",
    fill: "#FFF8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5544 116.387C58.0912 116.078 35.1636 114.595 23.4707 100.036L25.0393 98.2422C36.1488 112.073 58.5955 113.491 82.5778 113.794L82.5544 116.387Z",
    fill: "#FFF8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4106 177.741L75.2969 141.395L75.3746 141.099L90.1043 85.0714L96.7061 71.7359L122.832 54.8888L140.26 32.0059L141.869 33.7497L124.192 56.9598L98.2699 73.675L92.1028 86.1326L77.5266 141.579L82.5537 177.312L80.4106 177.741Z",
    fill: "#FFF8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.94 174.955L151.413 109.045L94.9788 84.3785L84.9343 81.5199L48.4783 78.2319L8.22391 113.427L6.93945 111.336L47.8412 75.5742L48.2416 75.6102L85.2701 78.9497L95.607 81.8915L95.6668 81.9176L152.923 106.944L153.119 107.368L183.842 173.701L181.94 174.955Z",
    fill: "#FFF8EB"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1016 85.601C95.1273 85.601 98.3908 82.259 98.3908 78.1364C98.3908 74.0139 95.1273 70.6719 91.1016 70.6719C87.076 70.6719 83.8125 74.0139 83.8125 78.1364C83.8125 82.259 87.076 85.601 91.1016 85.601Z",
    fill: "url(#paint13_linear_5241_15665)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1011 83.4859C93.9857 83.4859 96.3242 81.0914 96.3242 78.1375C96.3242 75.1836 93.9857 72.7891 91.1011 72.7891C88.2164 72.7891 85.8779 75.1836 85.8779 78.1375C85.8779 81.0914 88.2164 83.4859 91.1011 83.4859Z",
    fill: "#FA9C03"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M137.955 159.421C141.696 155.587 141.696 149.37 137.955 145.536C134.215 141.702 128.15 141.702 124.409 145.536C120.668 149.37 120.668 155.587 124.409 159.421C128.15 163.255 134.215 163.255 137.955 159.421Z",
    fill: "#FA9C03"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M179.448 44.0835C179.448 62.7547 152.01 110.39 137.716 133.887C136.607 135.711 134.218 136.818 129.794 136.818C127.697 136.818 128.522 135.706 127.413 133.882C113.119 110.384 85.6836 62.7526 85.6836 44.0835C85.6836 19.7367 106.674 0 132.566 0C158.458 0 179.448 19.7367 179.448 44.0835Z",
    fill: "#FA9C03"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M176.678 44.0835C176.678 62.7547 149.24 110.39 134.947 133.887C134.401 134.784 133.642 135.524 132.74 136.036C131.839 136.549 130.825 136.818 129.793 136.817C128.762 136.817 127.748 136.547 126.847 136.034C125.946 135.52 125.187 134.78 124.643 133.882C110.349 110.384 82.9141 62.7526 82.9141 44.0835C82.9141 19.7367 103.904 0 129.796 0C155.689 0 176.678 19.7367 176.678 44.0835Z",
    fill: "#FA9C03"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M151.171 66.8488C162.345 55.3958 162.345 36.8269 151.171 25.3739C139.996 13.9209 121.879 13.9209 110.705 25.3739C99.5303 36.8269 99.5303 55.3958 110.705 66.8488C121.879 78.3018 139.996 78.3018 151.171 66.8488Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M128.167 64.5508C139.657 64.5508 148.971 55.004 148.971 43.2275C148.971 31.451 139.657 21.9043 128.167 21.9043C116.677 21.9043 107.362 31.451 107.362 43.2275C107.362 55.004 116.677 64.5508 128.167 64.5508Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M129.794 83.3067C110.617 83.3067 95.0156 67.3164 95.0156 47.6608C95.0156 47.4914 95.0813 47.3289 95.1982 47.2091C95.3151 47.0893 95.4736 47.022 95.6389 47.022C95.8043 47.022 95.9628 47.0893 96.0797 47.2091C96.1966 47.3289 96.2622 47.4914 96.2622 47.6608C96.2622 66.612 111.304 82.0297 129.794 82.0297C148.285 82.0297 163.327 66.612 163.327 47.6608C163.327 28.7096 148.284 13.2926 129.794 13.2926C119.102 13.2926 109.299 18.3371 102.899 27.1323C102.798 27.2632 102.652 27.3488 102.49 27.3706C102.329 27.3925 102.166 27.349 102.036 27.2494C101.906 27.1498 101.818 27.002 101.793 26.8374C101.767 26.6729 101.806 26.5047 101.9 26.3686C108.538 17.247 118.706 12.0156 129.794 12.0156C148.971 12.0156 164.573 28.0059 164.573 47.6608C164.573 67.3157 148.971 83.3067 129.794 83.3067Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.421 132.66L38.148 173.597C37.5198 174.003 36.9802 174.538 36.5633 175.168C36.1464 175.798 35.8611 176.509 35.7254 177.258C35.5897 178.006 35.6065 178.775 35.7748 179.516C35.9431 180.258 36.2592 180.955 36.7033 181.565L37.0115 181.988C37.406 182.531 37.9012 182.987 38.4687 183.333C39.0361 183.678 39.6646 183.905 40.3179 184C40.9712 184.095 41.6364 184.057 42.2753 183.888C42.9142 183.719 43.5141 183.422 44.0406 183.014L104.05 136.519L101.421 132.66Z",
    fill: "#FA9C03"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M136.964 144.375C155.696 140.203 167.641 121.537 163.644 102.684C159.647 83.8312 141.221 71.93 122.489 76.102C103.757 80.2741 91.8116 98.9396 95.8088 117.793C99.806 136.646 118.232 148.547 136.964 144.375Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M121.679 72.2228C100.833 76.8661 87.5438 97.6372 91.993 118.615C96.4422 139.593 116.945 152.835 137.789 148.191C158.633 143.547 171.923 122.777 167.475 101.799C163.026 80.8205 142.522 67.5788 121.679 72.2228ZM136.608 142.611C118.826 146.573 101.334 135.278 97.5388 117.38C93.7432 99.4812 105.082 81.764 122.863 77.8025C140.645 73.8411 158.137 85.1359 161.933 103.034C165.729 120.931 154.388 138.65 136.606 142.611H136.608Z",
    fill: "#FA9C03"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7893 122.519C95.7711 122.516 95.7539 122.509 95.7396 122.497C95.7252 122.485 95.7144 122.469 95.7081 122.452C95.4068 121.582 95.135 120.689 94.8997 119.793C94.8935 119.767 94.8974 119.74 94.9105 119.717C94.9237 119.694 94.9451 119.677 94.9701 119.67C94.9951 119.663 95.0218 119.667 95.0444 119.68C95.067 119.693 95.0837 119.714 95.091 119.74C95.3249 120.629 95.5953 121.519 95.8952 122.384C95.9038 122.41 95.9023 122.437 95.891 122.462C95.8797 122.486 95.8594 122.505 95.8347 122.514C95.82 122.519 95.8046 122.52 95.7893 122.519ZM93.7941 111.84C93.7709 111.836 93.7495 111.825 93.7337 111.807C93.7178 111.79 93.7086 111.767 93.7075 111.743C93.6177 109.211 93.7919 106.676 94.2269 104.182C95.4577 97.1304 98.6988 90.627 103.597 85.3808C108.613 80.0084 115.049 76.3262 122.206 74.7333C128.895 73.2304 135.862 73.6901 142.307 76.0596C142.332 76.069 142.352 76.088 142.363 76.1126C142.374 76.1371 142.375 76.1651 142.366 76.1904C142.357 76.2158 142.338 76.2364 142.314 76.2477C142.29 76.259 142.263 76.2601 142.238 76.2507C135.828 73.8943 128.9 73.4366 122.248 74.93C115.128 76.5159 108.729 80.1783 103.741 85.5211C98.8687 90.7391 95.6462 97.2038 94.4223 104.218C93.9901 106.698 93.8171 109.218 93.9063 111.735C93.9068 111.749 93.9048 111.762 93.9003 111.774C93.8957 111.787 93.8888 111.798 93.8799 111.808C93.871 111.818 93.8603 111.826 93.8484 111.831C93.8365 111.837 93.8237 111.84 93.8107 111.84C93.8055 111.84 93.8004 111.839 93.7955 111.837L93.7941 111.84Z",
    fill: "#BDD0FB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3305 182.386C39.129 182.099 37.7971 181.126 37.3774 179.495C36.9509 177.831 37.6526 176.039 39.1208 175.043L46.6713 169.908C46.6821 169.901 46.6943 169.895 46.7071 169.893C46.7199 169.89 46.7331 169.89 46.746 169.893C46.7588 169.895 46.771 169.9 46.7818 169.908C46.7926 169.916 46.8019 169.925 46.8089 169.937C46.8163 169.948 46.8214 169.96 46.824 169.973C46.8266 169.986 46.8266 170 46.824 170.013C46.8215 170.026 46.8164 170.039 46.809 170.05C46.8017 170.061 46.7923 170.07 46.7814 170.078L39.2308 175.213C37.8315 176.164 37.1669 177.864 37.5701 179.444C37.9712 181.006 39.2604 181.932 41.4227 182.194C41.4473 182.199 41.4691 182.213 41.4837 182.234C41.4984 182.255 41.5048 182.281 41.5016 182.306C41.4985 182.332 41.4861 182.355 41.4668 182.371C41.4476 182.388 41.423 182.396 41.398 182.395L41.3305 182.386Z",
    fill: "#BDD0FB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0401 168.511C49.02 168.508 49.0012 168.5 48.9861 168.486C48.971 168.472 48.9604 168.454 48.9558 168.433C48.9511 168.413 48.9526 168.392 48.9601 168.373C48.9676 168.353 48.9806 168.337 48.9975 168.325L49.9765 167.661C49.9873 167.652 49.9996 167.646 50.0129 167.642C50.0261 167.638 50.0399 167.638 50.0534 167.64C50.067 167.642 50.0799 167.647 50.0914 167.655C50.1029 167.662 50.1128 167.672 50.1204 167.684C50.1279 167.696 50.1331 167.709 50.1354 167.723C50.1378 167.736 50.1374 167.751 50.1341 167.764C50.1309 167.778 50.1249 167.791 50.1166 167.802C50.1083 167.813 50.0979 167.822 50.0859 167.829L49.1069 168.495C49.0873 168.508 49.0636 168.514 49.0401 168.511Z",
    fill: "#BDD0FB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2386 187.639C38.2386 187.639 37.7453 190.35 37.4914 193.036C37.4684 193.285 37.495 193.536 37.5694 193.774C37.6437 194.013 37.7644 194.233 37.9242 194.422C38.084 194.611 38.2795 194.765 38.499 194.875C38.7184 194.984 38.9573 195.047 39.2011 195.059C42.6926 195.243 50.1613 195.606 52.843 195.509C52.9366 195.506 53.0279 195.479 53.1094 195.432C53.1909 195.384 53.2602 195.318 53.3116 195.237C53.3629 195.157 53.3948 195.065 53.4046 194.97C53.4144 194.875 53.4019 194.778 53.3679 194.689C53.2459 194.366 53.0075 194.103 52.702 193.955L40.4147 188.022L38.2386 187.639Z",
    fill: "#FA9C03"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8721 186.039L38.2161 189.291C38.2161 189.291 40.3687 190.344 41.8555 189.197L40.9982 185.568L37.8721 186.039Z",
    fill: "url(#paint14_linear_5241_15665)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7242 124.972C38.5536 125.818 37.4584 167.293 41.6138 185.925C41.6477 186.072 41.6291 186.226 41.5616 186.36C41.4941 186.494 41.382 186.599 41.2457 186.655C40.5797 186.927 39.2746 187.317 37.7157 187.355C37.4807 187.36 37.2506 187.286 37.0615 187.143C36.8723 187 36.7349 186.797 36.6706 186.565C35.4742 182.24 29.7495 160.572 29.1716 139.921C28.5222 116.846 29.1785 139.136 29.1785 139.136L29.8183 124.883L38.7242 124.972Z",
    fill: "#FFF8EB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0311 188.916C24.0311 188.916 23.2743 190.28 22.5175 193.915C22.4845 194.07 22.4838 194.23 22.5152 194.385C22.5466 194.54 22.6095 194.687 22.6998 194.816C22.7902 194.944 22.9059 195.052 23.0395 195.131C23.1731 195.211 23.3215 195.261 23.4752 195.278C24.6275 195.405 26.4018 195.572 27.8239 195.576C27.9786 195.577 28.1319 195.544 28.2735 195.48C28.4151 195.416 28.542 195.323 28.6459 195.205C28.7497 195.087 28.8283 194.949 28.8763 194.798C28.9243 194.647 28.9408 194.488 28.9246 194.33C28.7795 192.999 28.3089 190.812 26.8084 189.097L24.0311 188.916Z",
    fill: "#FA9C03"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.416 184.73L24.2491 189.652C24.2491 189.652 25.1112 190.322 26.8346 189.859L26.4645 184.57L23.416 184.73Z",
    fill: "url(#paint15_linear_5241_15665)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5869 126.076C17.8449 147.928 21.8511 180.178 23.2442 186.495C23.2853 186.684 23.3801 186.857 23.5167 186.991C23.6533 187.126 23.8257 187.215 24.012 187.25C24.6594 187.366 25.7258 187.466 26.7804 187.164C26.9578 187.112 27.115 187.005 27.2298 186.857C27.3446 186.71 27.4112 186.529 27.4202 186.34C27.6624 181.245 27.6032 149.955 31.0149 137.622C31.1877 136.998 31.5663 136.454 32.0861 136.083L38.5291 131.483L39.0898 123.951L21.5869 126.076Z",
    fill: "#FFF8EB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5204 84.8274C33.9179 84.5454 22.1899 87.4632 22.1899 87.4632C18.8532 106.335 21.2584 128.163 21.2584 128.163C29.4454 130.45 38.7407 126.985 38.7407 126.985C40.1786 119.097 46.7515 96.924 46.7515 96.924C51.9382 96.3154 56.2202 94.8255 59.7543 92.8342C57.1029 89.623 55.8769 85.5579 55.3513 83.1562C51.5935 84.3141 47.7904 84.9149 44.5204 84.8274Z",
    fill: "#FA9C03"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9894 69.126C74.9574 67.8264 73.6358 68.4208 73.6358 68.4208C72.0122 75.1612 63.7791 80.559 55.3486 83.1539C55.8756 85.5556 57.1016 89.6207 59.7517 92.8318C73.7775 84.9315 75.9894 69.126 75.9894 69.126Z",
    fill: "url(#paint16_linear_5241_15665)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7328 69.4504C75.8381 69.8065 74.5708 70.3346 73.8416 68.875C73.8223 68.179 73.437 65.1928 73.8478 64.6294C76.0376 61.6304 80.2632 57.8848 80.2632 57.8848C80.9649 58.6082 80.3746 59.3063 80.3746 59.3063L78.3217 61.457C78.74 62.2488 79.2518 62.9187 79.4864 63.8735C79.6578 64.6024 79.5489 65.371 79.1824 66.0199C78.8191 66.675 78.3245 67.5268 77.858 68.1924C76.9781 69.4525 75.7328 69.4504 75.7328 69.4504Z",
    fill: "url(#paint17_linear_5241_15665)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4223 62.8574L75.5545 64.4489L74.958 66.046L76.592 67.94C76.592 67.94 77.1774 64.7669 77.5964 64.0815C78.0154 63.3961 77.8062 63.0626 77.4223 62.8574Z",
    fill: "url(#paint18_linear_5241_15665)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1588 98.0238L22.1892 87.4609C22.1892 87.4609 12.2211 94.2612 10.5107 102.99C12.3807 103.15 15.7813 103.682 19.0988 105.44C19.8693 101.318 26.1588 98.0238 26.1588 98.0238Z",
    fill: "#FA9C03"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7212 108.015C34.7212 108.015 23.5415 114.347 19.8402 108.811C19.0724 107.661 18.8963 106.524 19.0985 105.444C15.7811 103.686 12.3804 103.154 10.5105 102.994C9.99449 105.626 10.2284 108.433 11.7131 111.282C18.1711 123.668 36.1666 110.839 36.1666 110.839L34.7212 108.015Z",
    fill: "url(#paint19_linear_5241_15665)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8599 75.8984L30.3931 85.8662C30.3649 85.9461 30.365 86.0336 30.3936 86.1133C30.4222 86.193 30.4774 86.2599 30.5493 86.302C31.4643 86.8315 34.7632 88.3708 38.781 85.8147C38.9885 85.6847 39.1653 85.5094 39.299 85.3012C39.4327 85.093 39.5199 84.8571 39.5543 84.6104L40.7273 75.9661L33.8599 75.8984Z",
    fill: "url(#paint20_linear_5241_15665)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2871 66.7109C41.2871 66.7109 44.9258 73.8948 44.4236 76.7781C43.9213 79.6614 39.3325 79.4083 35.3422 77.0242L32.6123 69.2783L41.2871 66.7109Z",
    fill: "url(#paint21_linear_5241_15665)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5594 73.2341C35.5979 73.2173 35.6323 73.1921 35.6603 73.1602C35.6883 73.1284 35.7091 73.0907 35.7215 73.0497C35.7338 73.0088 35.7372 72.9656 35.7316 72.9231C35.7259 72.8807 35.7113 72.84 35.6888 72.8039C35.3964 72.3364 34.8487 71.3831 34.6788 70.5475C34.6788 70.5475 34.017 70.104 36.3836 69.5476C38.7503 68.9913 42.2796 68.1268 43.0391 66.0741C43.7794 64.073 41.9308 59.0031 38.8679 62.9983C38.8411 63.034 38.8066 63.063 38.7671 63.0829C38.7276 63.1027 38.6842 63.1131 38.6402 63.1131C38.5962 63.1131 38.5528 63.1027 38.5133 63.0829C38.4738 63.063 38.4393 63.034 38.4125 62.9983C37.9233 62.332 36.632 60.9464 34.8144 61.7608C33.1137 62.5231 32.9107 63.7937 32.9279 64.4347C32.9295 64.4791 32.9211 64.5233 32.9036 64.5638C32.886 64.6044 32.8596 64.6404 32.8265 64.669C32.7933 64.6976 32.7542 64.7181 32.7122 64.729C32.6702 64.7398 32.6263 64.7407 32.5839 64.7316C31.7295 64.556 29.6758 64.3917 28.6961 66.5431C27.8898 68.3151 28.3934 69.3276 28.8571 69.8247C28.8916 69.8612 28.9163 69.9061 28.9288 69.9553C28.9412 70.0044 28.9411 70.056 28.9282 70.105C28.9154 70.1541 28.8904 70.1988 28.8556 70.235C28.8208 70.2712 28.7775 70.2974 28.7299 70.3113C28.165 70.4826 27.4337 70.9642 27.4915 72.3167C27.5747 74.186 29.6139 74.0414 30.1953 73.9618C30.242 73.955 30.2897 73.9602 30.3341 73.9768C30.3785 73.9934 30.4182 74.0209 30.4498 74.0569C30.9417 74.626 33.1611 77.0439 35.5849 77.357C35.6333 77.3625 35.6823 77.3554 35.7274 77.3365C35.7725 77.3175 35.8122 77.2871 35.8428 77.2483C35.8734 77.2094 35.8941 77.1633 35.9027 77.1142C35.9114 77.065 35.9078 77.0144 35.8924 76.967L34.8763 73.832C34.8533 73.7617 34.857 73.6851 34.8865 73.6175C34.9161 73.5498 34.9694 73.496 35.0359 73.4668L35.5594 73.2341Z",
    fill: "#FA9C03"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M35.975 73.6802C35.975 73.6802 33.3544 71.7989 33.1467 73.3594C32.9389 74.9198 35.5009 75.6454 36.7785 75.075L35.975 73.6802Z",
    fill: "url(#paint22_linear_5241_15665)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4396 118.02L38.5303 96.2212C38.5636 96.1003 38.6313 95.9923 38.7246 95.9108C38.8179 95.8293 38.9328 95.7781 39.0545 95.7636C40.1553 95.6317 43.3551 95.2615 47.0468 94.9414C51.4939 94.5557 56.6579 94.2433 59.7435 94.5091C59.8446 94.5175 59.9422 94.551 60.0277 94.6069C60.1133 94.6627 60.1843 94.7392 60.2345 94.8295C60.2846 94.9199 60.3125 95.0214 60.3157 95.1253C60.3188 95.2293 60.2972 95.3324 60.2526 95.4258C58.4975 99.0643 51.2792 113.866 47.6625 118.714C47.6038 118.794 47.5278 118.858 47.4406 118.902C47.3534 118.946 47.2574 118.968 47.1603 118.967L33.0299 118.832C32.9342 118.831 32.84 118.808 32.7546 118.764C32.6692 118.719 32.595 118.655 32.5378 118.577C32.4806 118.498 32.442 118.407 32.4249 118.31C32.4079 118.214 32.4129 118.115 32.4396 118.02Z",
    fill: "#FFF8EB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9128 112.754C33.9128 112.754 33.0645 109.178 33.4064 107.91C33.7483 106.641 34.4115 105.01 36.622 105.371C38.8325 105.732 41.4379 106.688 41.4379 106.688C41.4379 106.688 41.3058 108.341 39.6264 107.808L40.668 108.633C40.668 108.633 40.5187 109.957 39.1001 109.25L40.0688 110.345C40.0688 110.345 39.4599 111.432 38.4177 110.735C37.3754 110.037 36.8711 113.183 33.9128 112.754Z",
    fill: "url(#paint23_linear_5241_15665)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6396 101.447C46.6396 101.809 46.7446 102.164 46.9411 102.465C47.1377 102.767 47.417 103.002 47.7439 103.14C48.0707 103.279 48.4304 103.315 48.7774 103.245C49.1243 103.174 49.4431 102.999 49.6932 102.743C49.9434 102.487 50.1138 102.16 50.1828 101.804C50.2518 101.449 50.2164 101.08 50.081 100.745C49.9456 100.41 49.7163 100.124 49.4222 99.9223C49.128 99.7208 48.7822 99.6133 48.4284 99.6133C47.954 99.6133 47.499 99.8064 47.1636 100.15C46.8281 100.494 46.6396 100.96 46.6396 101.447Z",
    fill: "url(#paint24_linear_5241_15665)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2171 102.658L40.4555 98.346C40.5278 98.0889 40.6667 97.8567 40.8575 97.6741C41.0483 97.4915 41.2838 97.3652 41.539 97.3088C45.4254 96.4774 56.0629 96.3012 56.1696 96.2997L56.1627 95.8125C55.7238 95.8196 45.3724 95.9916 41.44 96.8321C41.1 96.9058 40.786 97.0728 40.5315 97.3152C40.2771 97.5577 40.0917 97.8665 39.9952 98.2085L38.7568 102.52L39.2171 102.658Z",
    fill: "#91B3FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5241_15665",
    x1: 64.8262,
    y1: 102.686,
    x2: 66.1251,
    y2: 102.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5241_15665",
    x1: 8.3877,
    y1: 100.042,
    x2: 65.1983,
    y2: 100.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5241_15665",
    x1: 5.90918,
    y1: 144.618,
    x2: 32.4597,
    y2: 144.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5241_15665",
    x1: 79.3799,
    y1: 111.804,
    x2: 126.786,
    y2: 111.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5241_15665",
    x1: 135.32,
    y1: 122.761,
    x2: 160.421,
    y2: 122.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5241_15665",
    x1: 148.409,
    y1: 51.7818,
    x2: 182.719,
    y2: 51.7818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5241_15665",
    x1: 81.251,
    y1: 61.2495,
    x2: 121.034,
    y2: 61.2495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5241_15665",
    x1: 40.4961,
    y1: 50.9809,
    x2: 65.6686,
    y2: 50.9809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5241_15665",
    x1: 139.48,
    y1: 45.8869,
    x2: 156.603,
    y2: 45.8869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5241_15665",
    x1: 165.192,
    y1: 114.478,
    x2: 183.537,
    y2: 114.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5241_15665",
    x1: 30.3574,
    y1: 160.636,
    x2: 80.3591,
    y2: 160.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5241_15665",
    x1: 78.9785,
    y1: 155.123,
    x2: 144.846,
    y2: 155.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5241_15665",
    x1: 151.566,
    y1: 48.5402,
    x2: 200.052,
    y2: -36.6799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5241_15665",
    x1: 83.8125,
    y1: 78.1364,
    x2: 98.3915,
    y2: 78.1364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5241_15665",
    x1: 37.8144,
    y1: 187.513,
    x2: 41.8286,
    y2: 187.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5241_15665",
    x1: 23.3499,
    y1: 187.16,
    x2: 26.8158,
    y2: 187.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5241_15665",
    x1: 55.3223,
    y1: 80.3393,
    x2: 75.8301,
    y2: 80.5278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5241_15665",
    x1: 74.3865,
    y1: 90.2532,
    x2: 76.102,
    y2: 73.5161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5241_15665",
    x1: 76.0491,
    y1: 52.2959,
    x2: 76.8513,
    y2: 79.9847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5241_15665",
    x1: 10.1738,
    y1: 109.677,
    x2: 36.1261,
    y2: 109.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5241_15665",
    x1: 30.3632,
    y1: 81.432,
    x2: 40.624,
    y2: 81.5263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5241_15665",
    x1: 42.6653,
    y1: 72.4142,
    x2: 31.2904,
    y2: 65.5372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5241_15665",
    x1: 39.6872,
    y1: 75.0169,
    x2: 29.4532,
    y2: 68.8299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5241_15665",
    x1: 33.3218,
    y1: 109.056,
    x2: 41.4358,
    y2: 109.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5241_15665",
    x1: 46.6383,
    y1: 101.446,
    x2: 50.2137,
    y2: 101.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIllustrationLogo);
export default __webpack_public_path__ + "static/media/AddressIllustrationLogo.c2c1475ffc671d4126bc266a969449ed.svg";
export { ForwardRef as ReactComponent };